import React from 'react';
import { Form } from 'formik';
import * as Styles from 'pages/member/wh/WH.style';
import Input from 'components/input';
import CustomButton from 'components/common/custom-button';
import { Icon } from 'semantic-ui-react';
import priceCalculator from 'utils/price-calculator';
import { H6 } from 'components/reusable-css';
import { Trans, useTranslation } from 'react-i18next';
import { UpperCaseWord } from 'assets/css/common-styles';
import { useSelector } from 'react-redux';

const WHDomainForm = ({ formikProp, domainLookUploading, parentValues }) => {
  const { t } = useTranslation();
  const userAccount = useSelector((state) => state.user.account);
  const { values, handleChange, handleBlur, errors, touched } = formikProp;
  const { result } = parentValues || {};

  return (
    <Form>
      <Styles.SearchDomainInput>
        <Input
          value={values['new_domain']}
          placeholder={t('wh/create.step1_string4')}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['new_domain']}
          touched={touched['new_domain']}
          styling={{
            width: '100%',
            marginTop: '-1em',
            marginRight: '1em',
          }}
          type="text"
          name={'new_domain'}
        />
        <CustomButton
          type="submit"
          title={'wh/create.step1_string5'}
          buttonStyles={{ height: '54px' }}
          isLoading={domainLookUploading}
        />
      </Styles.SearchDomainInput>
      {result?.available != undefined ? (
        result?.available ? (
          <Styles.AvailDomainContainer>
            <div className="domain">
              <div className="isDomainAvail">
                <Icon name="check" />
                <H6 className="para">{t('wh/create.step1_string11')}</H6>
              </div>
            </div>
            <div className="domainpriceCon">
              <H6 className="para">
                <span>
                  <Trans
                    i18nKey="wh/create.step1_string12"
                    values={{
                      price: priceCalculator(result?.price || 0),
                      currency: userAccount.account_currency,
                    }}
                    components={{ price: <Styles.PriceUnit />, uppercase: <UpperCaseWord /> }}
                  />
                </span>
              </H6>
            </div>
          </Styles.AvailDomainContainer>
        ) : (
          <Styles.NotAvailDomainContainer>
            <div className="domain">
              <div className="isDomainAvail">
                <Icon name="ban" />
                <H6 className="para">{t('wh/create.step1_string13')}</H6>
              </div>
            </div>
          </Styles.NotAvailDomainContainer>
        )
      ) : null}
    </Form>
  );
};

export default WHDomainForm;
